export const useKnowledge = {
  getAll(params) {
    return useAPI().get(`knowledges`, {
      params,
    }) as Promise<knowledgesAttributes[]>
  },
  get({ knowledgeId, params }) {
    return useAPI().get(`knowledges/${knowledgeId}`, { params }) as Promise<knowledgesAttributes>
  },
  update({ knowledgeId, knowledge }: { knowledgeId: number; knowledge: knowledgesAttributes}) {
    return useAPI().put(`knowledges/${knowledgeId}`, { body: knowledge }) 
  },
  delete({ knowledgeId }) {
    return useAPI().delete(`knowledges/${knowledgeId}`, {})
  },
  add(knowledge) {
    return useAPI().post(`knowledges`, { body: knowledge })
  },
  getLastestNews(params) {
    return useAPI().get(`big_news`, { params }) as Promise<knowledgesAttributes[]>
  },
}
